
const nid = require('nid')

const localStore = require('store')

// Retain the latest x states in localStorage journey history
localStore.keepThisManyStates = 50;

// The localStorage key name to use (was previously named "journey")
localStore.storageKey = 'journeystate';

localStore.getJourney = function() {
    return this.get(this.storageKey) || [];
};

localStore.setJourney = function(journey) {
    this.set(this.storageKey, journey || []);
};

localStore.setStateid = function(stateid) {
    let journey = this.getJourney();
    let nid_hex = nid({hex:1});
    let guid = nid_hex(4).toString(); // <- SUPER IMPORTANT TO USE ".toString()"

    // Add the latest state to the top of the array
    journey.unshift({
        "guid"   : guid,               // <- Used in the browser url route eg: #/state/{guid}
        "stateid": stateid.toString(), // <- SUPER IMPORTANT TO USE ".toString()"
        "ts"     : +new Date()         // <- Timestamp (could be used to future to remove really old states)
    });

    // Only keep the last x states
    journey = journey.splice(0, this.keepThisManyStates);

    this.setJourney(journey);

    return guid;
};

localStore.getStateid = function(guid) {
    let journey = this.getJourney();
    let state = journey.filter(o => { return o.guid == guid; })[0] || {};
    return state.stateid || 0;
};

localStore.clearAll = function() {
    this.setJourney([]);
};

export default localStore;
